import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-surface px-5 py-16 sm:px-8 sm:py-20" aria-labelledby="garantia-title" data-id="element-113" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-3xl rounded-[2rem] border border-gold/30 bg-ink p-8 text-center sm:p-12" data-id="element-114" data-mp="9tl5soqen3q3">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gold/12" aria-hidden="true" data-id="element-115" data-mp="ev0sel88dial">
          <ShieldCheckIcon className="h-7 w-7 text-gold" data-id="element-116" data-mp="ntvxftzjgmcb" />
        </span>
        <h2 id="garantia-title" className="mt-6 text-2xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-117" data-mp="ns1a690soi52">
          🛡️ Garantía 7 días — sin preguntas
        </h2>
        <p className="mt-5 text-base leading-relaxed text-neutral-300" data-id="element-118" data-mp="12j0hlgpw90n2">
          Abrís los tomos. Los aplicás en tu entrenamiento. Si en 7 días no es
          lo que esperabas:
        </p>
        <p className="mt-3 text-xl font-extrabold tracking-tight text-gold sm:text-2xl" data-id="element-119" data-mp="17fqu5u2hpe3q">
          devolución del 100% sin formularios, sin drama.
        </p>
        <p className="mt-5 text-sm text-neutral-500" data-id="element-120" data-mp="20s2kiqdf4gh3">
          Tasa de devoluciones: menos del 1%.
        </p>
      </div>
    </section>;
}